export const ADD_USER_TO_JOURNAL = 'journal/ADD_USER_TO_JOURNAL'
export const ADD_BUSINESS_TO_JOURNAL = 'journal/ADD_BUSINESS_TO_JOURNAL'
export const CLOSE_CLIENTS_SPLASH_SCREEN = 'journal/CLOSE_CLIENTS_SPLASH_SCREEN'
export const CLOSE_TIMEZONE_ALERT = 'journal/CLOSE_TIMEZONE_ALERT'
